import axios from "axios"
import baseURL from "../config/api"

export const getUsername = (username: string, token: string, id?: string) => {
    const url = id
        ? `users/DoesUserNameExist/${encodeURIComponent(username)}?id=${id}`
        : `users/DoesUserNameExist/${encodeURIComponent(username)}`;

    return getFetch(url, token);
}

export const getFamilyMemberUsername = (username: string, token: string, id?: string) => {
    const url = id
        ? `FamilyMember/DoesFamilyMemberUserNameExist/${encodeURIComponent(username)}?id=${id}`
        : `FamilyMember/DoesFamilyMemberUserNameExist/${encodeURIComponent(username)}`;

    return getFetch(url, token);
}

const getFetch = (url: string, token: string, params = {}) => {
    return axios({
        url: baseURL + url,
        method: "GET",
        headers: {
            Authorization: `Bearer ${token}`
        },
        params: params
    }).then(response => response.data);
}